/**
 * @param dataWrapper {ReturnType<import('core/data/data-wrapper')._DB>}
 */
export function createLoanRepository(dataWrapper) {
  const LOAN_FINANCIAL_DOCUMENT_KEY = 'loan_financial'
  const LOAN_HEALTH_DOCUMENT_KEY = 'loan_health'
  const { list } = dataWrapper

  const _listFinancialTable = (list) => list(LOAN_FINANCIAL_DOCUMENT_KEY)

  const listFinancialTable = () => _listFinancialTable(list)

  const _listHealthCheckTable = (list) => list(LOAN_HEALTH_DOCUMENT_KEY)

  const listHealthCheckTable = () => _listHealthCheckTable(list)

  return {
    _listFinancialTable,
    listFinancialTable,
    _listHealthCheckTable,
    listHealthCheckTable,
  }
}
